import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

export const BIG_POPUP_WIDTH = "min(1300px, 100dvw)";
export const MEDIUM_POPUP_WIDTH = "min(900px, 100dvw)";
export const SMALL_POPUP_WIDTH = "min(600px, 100dvw)";
export const XS_POPUP_WIDTH = "min(400px, 100dvw)";

export const BIG_POPUP_HEIGHT = "90dvh";
export const MEDIUM_POPUP_HEIGHT = "80dvh";
export const SMALL_POPUP_HEIGHT = "60dvh";
export const XS_POPUP_HEIGHT = "40dvh";

// Augment the theme module to add our custom theme keys
declare module "@mui/material/styles" {
  interface Palette {
    tertiary: Palette["primary"];
    greyBackground: {
      main: string;
      secondary: string;
    };
    disabled: Palette["primary"];
  }

  interface PaletteOptions {
    tertiary: {
      main: string;
      transparent: string;
    };
    disabled: {
      main: string;
      secondary: string;
    };
    greyBackground: {
      main: string;
      secondary: string;
    };
  }
}

// Augment the initial theme to add the custom pallettes
const theme = createTheme({
  palette: {
    primary: {
      main: "#0e2841",
      contrastText: "#fff",
    },
    secondary: {
      main: "rgba(108, 127, 147, 0.8)",
    },
    tertiary: {
      main: "#aab9c9",
      transparent: "rgba(167, 192, 217, 0.8)",
    },
    greyBackground: {
      main: grey[400],
      secondary: grey[200],
    },
    error: {
      main: "#FF4444",
    },
    success: {
      main: "#00C851",
    },
    warning: {
      main: "#FFBB33",
    },
    disabled: {
      main: grey[500],
      secondary: "rgba(195, 187, 185, 0.5)",
    },
  },
  typography: {
    body1: {
      fontWeight: 400,
      fontSize: "clamp(12px, 1.5rem, 14px)",
    },
    body2: {
      fontWeight: 400,
      fontSize: "clamp(10px, 1.25rem, 12px)",
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: "clamp(14px, 1.75rem, 20px)",
    },
    h4: {
      fontWeight: 500,
      fontSize: "clamp(16px, 2rem, 22px)",
    },
  },
});

export default theme;
